/** 
*@author: satyamurthy.a
*@Description : 
**/
import axios from 'axios';
import { Select } from 'antd';
import React, { useEffect, useState } from 'react';
import localStorage from '../../../utils/localStorage';

const { Option } = Select;

const SelectComponent = ({ column, value, handleFieldChange }) => {
  const [optionList, setOptionList] = useState([]);

  useEffect(() => {
    const getOptionList = async (column) => {
      let payloadHeader = {};
      const accessToken = localStorage.get('accessToken');

      if (column && column.url && column.method === 'GET') {
        payloadHeader = {
          method: column.method,
          url: `${column.url}`,
          headers: {
            Authorization: `Bearer ${accessToken}`
          }
        };
      } else if (column && column.url && column.method === 'POST') {
        payloadHeader = {
          method: column.method,
          url: `${column.url}`,
          headers: {
            Authorization: `Bearer ${accessToken}`
          },
          data: JSON.parse(column.payload)
        };
      }

      try {
        const response = await axios(payloadHeader);
        if (Array.isArray(response.data)) {
          setOptionList(response.data);
        }
      } catch {
        setOptionList([]);
      }
    };

    getOptionList(column);
  }, [column]);

  return (
    <div>
      <Select
        value={value}
        style={{ width: 251 }}
        onChange={(e) => handleFieldChange(e, column.key)}
        placeholder={column.placeHolder || column.displayName}
      >
        {optionList.map((data, index) => (
          <Option key={index} value={data.value}>
            {data.key}
          </Option>
        ))}
      </Select>
    </div>
  );
};

export default SelectComponent;